import { getDailyPricesSum } from './getDailyPricesSum'
import { getTotalAdultsPrice } from './getTotalAdultsPrice'
import { getTotalChildrenPrice } from './getTotalChildrenPrice'
import { paymentTypes } from 'Rentlio/utils/services'
import { getNights } from 'Rentlio/state/selectors/request'
import { servicePricingTypeEnum } from 'Rentlio/utils/servicePricingTypeEnum'

function getServiceCostBeforeTaxLegacy(service, request) {
  const { priceBeforeTax, quantity, paymentType, isMandatory } = service
  const nights = getNights(request)

  if (isMandatory) {
    // mandatory services use real price model that
    // was already applied for getting correct quantity
    return quantity * priceBeforeTax
  }

  switch (paymentType) {
    case paymentTypes.PER_PERSON:
    case paymentTypes.PER_ADULT:
    case paymentTypes.PER_CHILDREN_UNDER_12:
    case paymentTypes.PER_CHILDREN_ABOVE_12:
    case paymentTypes.ONE_TIME_FEE:
      return quantity * priceBeforeTax
    case paymentTypes.PER_NIGHT:
    case paymentTypes.PER_PERSON_PER_NIGHT:
      return nights * priceBeforeTax * quantity
  }

  // if paymentType = 0
  return quantity * priceBeforeTax
}

function getServiceCostBeforeTaxWithPricingDynamic(service, request) {
  const { dailyPrices, quantity, pricingType } = service

  const basePrice = getDailyPricesSum(dailyPrices, 'priceBeforeTax')

  if (pricingType === servicePricingTypeEnum.PER_PERSON) {
    const priceForAdults = getTotalAdultsPrice(basePrice, request, service)
    const childrenPrice = getTotalChildrenPrice(basePrice, request, service)

    return quantity * (priceForAdults + childrenPrice)
  }

  return quantity * basePrice
}

export function getServiceCostsBeforeTax(service, request) {
  const { paymentType } = service

  if (typeof paymentType !== 'undefined' && paymentType !== null) {
    return getServiceCostBeforeTaxLegacy(service, request)
  }

  return getServiceCostBeforeTaxWithPricingDynamic(service, request)
}
